import { Card } from '../../components/ui/Card.jsx';
import { nomComplet } from '../../lib/acces';
import { tr } from '../../lib/i18n';
import { moisDe } from '../../lib/salaires-periode';
import { hours } from '../../lib/utils';
import { C } from '../../theme/palette';
import { fmtH } from '../../lib/currency';

const MOIS = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

const cellule = { padding: '6px 4px', fontSize: 10, textAlign: 'left' };

/**
 * Les heures du chantier, mois par mois et employé par employé.
 *
 * <p>L'onglet Heures n'était qu'une liste de pointages : pour savoir combien
 * d'heures Paul avait faites en février sur le chantier, il fallait les
 * additionner à la main.
 *
 * @param {object} props propriétés
 * @param {object[]} [props.pointages] pointages du chantier
 * @param {object[]} [props.employes] fiches du personnel, pour les noms
 * @returns {import('react').ReactElement|null} le tableau, ou rien sans heures
 */
export function HeuresParMois({ pointages, employes }) {
  const parMois = {};
  (pointages || [])
    .filter((p) => p.type !== 'absence')
    .forEach((p) => {
      const m = moisDe(p.date);
      const h = hours(p.entree, p.sortie, p.pause);
      if (!m || !(h > 0)) return;
      const e = (employes || []).find((x) => x.id === p.empId);
      const nom = (e && (nomComplet(e) || e.nom)) || p.empNom || tr('Employé');
      const mois = (parMois[m] = parMois[m] || {});
      mois[nom] = (mois[nom] || 0) + h;
    });
  const mois = Object.keys(parMois).sort().reverse();
  if (!mois.length) return null;
  return (
    <Card style={{ marginBottom: 10 }}>
      <div style={{ padding: '11px 13px' }}>
        <div style={{ fontSize: 11, fontWeight: 900, color: C.ink, marginBottom: 4 }}>
          {tr('⏱ Heures par mois')}
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {mois.flatMap((m) => {
              const lignes = Object.entries(parMois[m]).sort((a, b) => a[0].localeCompare(b[0]));
              const total = lignes.reduce((t, [, h]) => t + h, 0);
              return [
                <tr key={m} style={{ borderTop: '1px solid ' + C.border }}>
                  <td style={{ ...cellule, fontWeight: 900 }}>
                    {tr(MOIS[+m.slice(5, 7) - 1]) + ' ' + m.slice(0, 4)}
                  </td>
                  <td style={{ ...cellule, textAlign: 'right', fontWeight: 900 }}>{fmtH(total)}</td>
                </tr>,
                ...lignes.map(([nom, h]) => (
                  <tr key={m + nom}>
                    <td style={{ ...cellule, color: C.grey, paddingLeft: 14 }}>{nom}</td>
                    <td style={{ ...cellule, textAlign: 'right', fontWeight: 700 }}>{fmtH(h)}</td>
                  </tr>
                )),
              ];
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
